var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper blank-wrapper"},[_c('router-view'),_c('loading',{attrs:{"active":_vm.$store.state.loading.status},on:{"update:active":function($event){return _vm.$set(_vm.$store.state.loading, "status", $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }